var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimeTrackerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_dashboard",
    d: "M14,4A10,10,0,1,0,24,14,10.011,10.011,0,0,0,14,4Zm0,1.5A8.5,8.5,0,1,1,5.5,14,8.489,8.489,0,0,1,14,5.5Zm0,.75a.75.75,0,1,0,.75.75A.75.75,0,0,0,14,6.25ZM9.051,8.3a.75.75,0,1,0,.75.75A.75.75,0,0,0,9.051,8.3Zm9.9,0a.75.75,0,1,0,.75.75A.75.75,0,0,0,18.949,8.3Zm.3,3.308a30.075,30.075,0,0,0-5.632,1.468,1,1,0,1,0,.766,1.848c.51-.212,5.372-2.71,5.16-3.22C19.517,11.64,19.413,11.611,19.249,11.608ZM7,13.25a.75.75,0,1,0,.75.75A.75.75,0,0,0,7,13.25Zm14,0a.75.75,0,1,0,.75.75A.75.75,0,0,0,21,13.25ZM9.051,18.2a.75.75,0,1,0,.75.75A.75.75,0,0,0,9.051,18.2Zm9.9,0a.75.75,0,1,0,.75.75A.75.75,0,0,0,18.949,18.2Z",
    transform: "translate(-4 -4)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeTrackerActive);
export default __webpack_public_path__ + "static/media/iconTimeTrackerActive.98616a56ba26ab8809f436161e909dc1.svg";
export { ForwardRef as ReactComponent };